import React from "react";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Steps from "./components/Steps";
import AdFormats from "./components/AdFormats";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Monetization from "./components/Monetization";

function App() {
  return (
    <div>
      <Hero />
      <Monetization />
      <Features />
      <Steps />
      <AdFormats />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
